export default __webpack_public_path__ + "static/media/t4.2c50a36f.svg";